export const dashBoardData = [
    {
        topic: "Arrays & Hashing",
        items: [
            {
                id: "1",
                title: "Contains Duplicate",
                vidLink: "https://youtu.be/3OamzN90kPg",
                probLink: "https://leetcode.com/problems/contains-duplicate/",
                lvl: "E"
            }, 
            {
                id: "2",
                title: "Valid Anagram",
                vidLink: "https://youtu.be/9UtInBqnCgA",
                probLink: "https://leetcode.com/problems/valid-anagram/description/",
                lvl: "E"
            },
            {
                id: "3",
                title: "Two Sum",
                vidLink: "https://youtu.be/KLlXCFG5TnA",
                probLink: "https://leetcode.com/problems/two-sum/description/",
                lvl: "E"
            },
            {
                id: "4",
                title: "Group Anagrams",
                vidLink: "https://youtu.be/vzdNOK2oB2E",
                probLink: "https://leetcode.com/problems/group-anagrams/description/",
                lvl: "M"
            },
            {
                id: "5",
                title: "Top K Frequent Elements",
                vidLink: "https://youtu.be/YPTqKIgVk-k",
                probLink: "https://leetcode.com/problems/top-k-frequent-elements/description/",
                lvl: "M"
            },
            {
                id: "6",
                title: "Encode and Decode Strings",
                vidLink: "https://youtu.be/B1k_sxOSgv8",
                probLink: "https://leetcode.com/problems/encode-and-decode-strings/description/",
                lvl: "M",
                prob: true
            }, 
            {
                id: "7",
                title: "Product of Array Except Self",
                vidLink: "https://youtu.be/bNvIQI2wAjk",
                probLink: "https://leetcode.com/problems/product-of-array-except-self/description/",
                lvl: "M"
            },
            {
                id: "8",
                title: "Valid Sudoku",
                vidLink: "https://youtu.be/TjFXEUCMqI8",
                probLink: "https://leetcode.com/problems/valid-sudoku/description/",
                lvl: "M"
            },
            {
                id: "9",
                title: "Longest Consecutive Sequence",
                vidLink: "https://youtu.be/P6RZZMu_maU",
                probLink: "https://leetcode.com/problems/longest-consecutive-sequence/description/",
                lvl: "M"
            }
              
        ]
    },
    {
        topic: "Two Pointers",
        items: [
            {
                id: "1",
                title: "Valid Palindrome",
                vidLink: "https://youtu.be/jJXJ16kPFWg",
                probLink: "https://leetcode.com/problems/valid-palindrome/description/",
                lvl: "E"
            }, 
            {
                id: "2",
                title: "Two Sum II Input Array Is Sorted",
                vidLink: "https://youtu.be/cQ1Oz4ckceM",
                probLink: "https://leetcode.com/problems/two-sum-ii-input-array-is-sorted/description/",
                lvl: "M"
            },
            {
                id: "3",
                title: "3Sum",
                vidLink: "https://youtu.be/jzZsG8n2R9A",
                probLink: "https://leetcode.com/problems/3sum/description/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Container With Most Water",
                vidLink: "https://youtu.be/UuiTKBwPgAo",
                probLink: "https://leetcode.com/problems/container-with-most-water/description/",
                lvl: "M"
            },
            {
                id: "5",
                title: "Trapping Rain Water",
                vidLink: "https://youtu.be/ZI2z5pq0TqA",
                probLink: "https://leetcode.com/problems/trapping-rain-water/description/",
                lvl: "H"
            }
        ]
    },
    {
        topic: "Stack",
        items: [
            {
                id: "1",
                title: "Valid Parentheses",
                vidLink: "https://youtu.be/WTzjTskDFMg",
                probLink: "https://leetcode.com/problems/valid-parentheses/description/",
                lvl: "E"
            },
            {
                id: "2",
                title: "Min Stack",
                vidLink: "https://youtu.be/qkLl7nAwDPo",
                probLink: "https://leetcode.com/problems/min-stack/description/",
                lvl: "M"
            },
            {
                id: "3",
                title: "Evaluate Reverse Polish Notation",
                vidLink: "https://youtu.be/iu0082c4HDE",
                probLink: "https://leetcode.com/problems/evaluate-reverse-polish-notation/description/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Generate Parentheses",
                vidLink: "https://youtu.be/s9fokUqJ76A",
                probLink: "https://leetcode.com/problems/generate-parentheses/description/",
                lvl: "M"
            },
            {
                id: "5",
                title: "Daily Temperatures",
                vidLink: "https://youtu.be/cTBiBSnjO3c",
                probLink: "https://leetcode.com/problems/daily-temperatures/description/",
                lvl: "M"
            },
            {
                id: "6",
                title: "Car Fleet",
                vidLink: "https://youtu.be/Pr6T-3yB9RM",
                probLink: "https://leetcode.com/problems/car-fleet/description/",
                lvl: "M"
            },
            {
                id: "7",
                title: "Largest Rectangle In Histogram",
                vidLink: "https://youtu.be/zx5Sw9130L0",
                probLink: "https://leetcode.com/problems/largest-rectangle-in-histogram/description/",
                lvl: "H"
            }
        ]
    },
    {
        topic: "Sliding Window",
        items: [
            {
                id: "1",
                title: "Best Time to Buy And Sell Stock",
                vidLink: "https://youtu.be/1pkOgXD63yU",
                probLink: "https://neetcode.io/problems/buy-and-sell-crypto/",
                lvl:"E"
            },
            {
                id: "2",
                title: "Longest Substring Without Repeating Characters",
                vidLink: "https://youtu.be/wiGpQwVHdE0",
                probLink: "https://neetcode.io/problems/longest-substring-without-duplicates/",
                lvl: "M"
            },
            {
                id: "3",
                title: "Longest Repeating Character Replacement",
                vidLink: "https://youtu.be/gqXU1UyA8pk",
                probLink: "https://neetcode.io/problems/longest-repeating-substring-with-replacement/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Permutation In String",
                vidLink: "https://youtu.be/UbyhOgBN834",
                probLink: "https://neetcode.io/problems/permutation-string/",
                lvl: "M"
            },
            {
                id: "5",
                title: "Minimum Window Substring",
                vidLink: "https://youtu.be/jSto0O4AJbM",
                probLink: "https://neetcode.io/problems/minimum-window-with-characters/",
                lvl: "H"
            },
            {
                id: "6",
                title: "Sliding Window Maximum",
                vidLink: "https://youtu.be/DfljaUwZsOk",
                probLink: "https://neetcode.io/problems/sliding-window-maximum/",
                lvl: "H"
            }
        ]
    },
    {
        topic: "Linked List",
        items: [
            {
                id: "1",
                title: "Reverse Linked List",
                vidLink: "https://youtu.be/G0_I-ZF0S38",
                probLink: "https://neetcode.io/problems/reverse-a-linked-list/",
                lvl: "E"
            },
            {
                id: "2",
                title: "Merge Two Sorted Lists",
                vidLink: "https://youtu.be/XIdigk956u0",
                probLink: "https://neetcode.io/problems/merge-two-sorted-linked-lists/",
                lvl: "E"
            },
            {
                id: "3",
                title: "Reorder List",
                vidLink: "https://youtu.be/S5bfdUTrKLM",
                probLink: "https://neetcode.io/problems/reorder-linked-list/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Remove Nth Node From End of List",
                vidLink: "https://youtu.be/XVuQxVej6y8",
                probLink: "https://neetcode.io/problems/remove-node-from-end-of-linked-list/",
                lvl: "M"
            },
            {
                id: "5",
                title: "Copy List With Random Pointer",
                vidLink: "https://youtu.be/5Y2EiZST97Y",
                probLink: "https://neetcode.io/problems/copy-linked-list-with-random-pointer/",
                lvl: "M"
            },
            {
                id: "6",
                title: "Add Two Numbers",
                vidLink: "https://youtu.be/wgFPrzTjm7s",
                probLink: "https://neetcode.io/problems/add-two-numbers/",
                lvl: "M"
            },
            {
                id: "7",
                title: "Linked List Cycle",
                vidLink: "https://youtu.be/gBTe7lFR3vc",
                probLink: "https://neetcode.io/problems/linked-list-cycle-detection/",
                lvl: "E"
            },
            {
                id: "8",
                title: "Find The Duplicate Number",
                vidLink: "https://youtu.be/wjYnzkAhcNk",
                probLink: "https://neetcode.io/problems/find-duplicate-integer/",
                lvl: "M"
            },
            {
                id: "9",
                title: "LRU Cache",
                vidLink: "https://youtu.be/7ABFKPK2hD4",
                probLink: "https://neetcode.io/problems/lru-cache/",
                lvl: "M"
            },
            {
                id: "10",
                title: "Merge K Sorted Lists",
                vidLink: "https://youtu.be/q5a5OiGbT6Q",
                probLink: "https://neetcode.io/problems/merge-k-sorted-linked-lists/",
                lvl: "H"
            },
            {
                id: "11",
                title: "Reverse Nodes In K Group",
                vidLink: "https://youtu.be/1UOPsfP85V4",
                probLink: "https://neetcode.io/problems/reverse-nodes-in-k-group/",
                lvl: "H"
            }
        ]
    },
    {
        topic: "Binary Search",
        items: [
            {
                id: "1",
                title: "Binary Search",
                vidLink: "https://youtu.be/s4DPM8ct1pI",
                probLink: "https://neetcode.io/problems/binary-search/",
                lvl: "E"
            },
            {
                id: "2",
                title: "Search a 2D Matrix",
                vidLink: "https://youtu.be/Ber2pi2C0j0",
                probLink: "https://neetcode.io/problems/search-2d-matrix/",
                lvl: "M"
            },
            {
                id: "3",
                title: "Koko Eating Bananas",
                vidLink: "https://youtu.be/U2SozAs9RzA",
                probLink: "https://neetcode.io/problems/eating-bananas/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Find Minimum In Rotated Sorted Array",
                vidLink: "https://youtu.be/nIVW4P8b1VA",
                probLink: "https://neetcode.io/problems/find-minimum-in-rotated-sorted-array/",
                lvl: "M"
            },
            {
                id: "5",
                title: "Search In Rotated Sorted Array",
                vidLink: "https://youtu.be/U8XENwh8Oy8",
                probLink: "https://neetcode.io/problems/find-target-in-rotated-sorted-array/",
                lvl: "M"
            },
            {
                id: "6",
                title: "Time Based Key Value Store",
                vidLink: "https://youtu.be/fu2cD_6E8Hw",
                probLink: "https://neetcode.io/problems/time-based-key-value-store/",
                lvl: "M"
            },
            {
                id: "7",
                title: "Median of Two Sorted Arrays",
                vidLink: "https://youtu.be/q6IEA26hvXc",
                probLink: "https://neetcode.io/problems/median-of-two-sorted-arrays/",
                lvl: "H"
            }
        ]
    },
    {
        topic: "Trees",
        items: [
            {
                id: "1",
                title: "Invert Binary Tree",
                vidLink: "https://youtu.be/OnSn2XEQ4MY",
                probLink: "https://leetcode.com/problems/invert-binary-tree/description/",
                lvl: "E"
            },
            {
                id: "2",
                title: "Maximum Depth of Binary Tree",
                vidLink: "https://youtu.be/hTM3phVI6YQ",
                probLink: "https://leetcode.com/problems/maximum-depth-of-binary-tree/description/",
                lvl: "E"
            },
            {
                id: "3",
                title: "Diameter of Binary Tree",
                vidLink: "https://youtu.be/K81C31ytOZE",
                probLink: "https://leetcode.com/problems/diameter-of-binary-tree/description/",
                lvl: "E"
            },
            {
                id: "4",
                title: "Balanced Binary Tree",
                vidLink: "https://youtu.be/QfJsau0ItOY",
                probLink: "https://leetcode.com/problems/balanced-binary-tree/description/",
                lvl: "E"
            },
            {
                id: "5",
                title: "Same Tree",
                vidLink: "https://youtu.be/vRbbcKXCxOw",
                probLink: "https://leetcode.com/problems/subtree-of-another-tree/description/",
                lvl: "E"
            },
            {
                id: "6",
                title: "Subtree of Another Tree",
                vidLink: "https://youtu.be/E36O5SWp-LE",
                probLink: "https://leetcode.com/problems/subtree-of-another-tree/description/",
                lvl: "E"
            },
            {
                id: "7",
                title: "Lowest Common Ancestor of a Binary Search Tree",
                vidLink: "https://youtu.be/gs2LMfuOR9k",
                probLink: "https://leetcode.com/problems/lowest-common-ancestor-of-a-binary-search-tree/description/",
                lvl: "M"
            },
            {
                id: "8",
                title: "Binary Tree Level Order Traversal",
                vidLink: "https://youtu.be/6ZnyEApgFYg",
                probLink: "https://leetcode.com/problems/binary-tree-level-order-traversal/description/",
                lvl: "M"
            },
            {
                id: "9",
                title: "Binary Tree Right Side View",
                vidLink: "https://youtu.be/d4zLyf32e3I",
                probLink: "https://leetcode.com/problems/binary-tree-right-side-view/description/",
                lvl: "M"
            },
            {
                id: "10",
                title: "Count Good Nodes In Binary Tree",
                vidLink: "https://youtu.be/7cp5imvDzl4",
                probLink: "https://leetcode.com/problems/count-good-nodes-in-binary-tree/description/",
                lvl: "M"
            },
            {
                id: "11",
                title: "Validate Binary Search Tree",
                vidLink: "https://youtu.be/s6ATEkipzow",
                probLink: "https://leetcode.com/problems/validate-binary-search-tree/description/",
                lvl: "M"
            },
            {
                id: "12",
                title: "Kth Smallest Element In a Bst",
                vidLink: "https://youtu.be/5LUXSvjmGCw",
                probLink: "https://leetcode.com/problems/kth-smallest-element-in-a-bst/description/",
                lvl: "M"
            },
            {
                id: "13",
                title: "Construct Binary Tree From Preorder And Inorder Traversal",
                vidLink: "https://youtu.be/ihj4IQGZ2zc",
                probLink: "https://leetcode.com/problems/construct-binary-tree-from-preorder-and-inorder-traversal/description/",
                lvl: "M"
            },
            {
                id: "14",
                title: "Binary Tree Maximum Path Sum",
                vidLink: "https://youtu.be/Hr5cWUld4vU",
                probLink: "https://leetcode.com/problems/binary-tree-maximum-path-sum/description/",
                lvl: "H"
            },
            {
                id: "15",
                title: "Serialize And Deserialize Binary Tree",
                vidLink: "https://youtu.be/u4JAi2JJhI8",
                probLink: "https://leetcode.com/problems/serialize-and-deserialize-binary-tree/description/",
                lvl: "H"
            }
        ]
    },
    {
        topic: "Tries",
        items: [
            {
                id: "1",
                title: "Implement Trie Prefix Tree",
                vidLink: "https://youtu.be/oobqoCJlHA0",
                probLink: "https://leetcode.com/problems/implement-trie-prefix-tree/description/",
                lvl: "M"
            },
            {
                id: "2",
                title: "Design Add And Search Words Data Structure",
                vidLink: "https://youtu.be/BTf05gs_8iU",
                probLink: "https://leetcode.com/problems/design-add-and-search-words-data-structure/description/",
                lvl: "M"
            },
            {
                id: "3",
                title: "Word Search II",
                vidLink: "https://youtu.be/asbcE9mZz_U",
                probLink: "https://leetcode.com/problems/word-search-ii/description/",
                lvl: "H"
            }
        ]
    },
    {
        topic: "Heap / Priority Queue",
        items: [
            {
                id: "1",
                title: "Kth Largest Element In a Stream",
                vidLink: "https://youtu.be/hOjcdrqMoQ8",
                probLink: "https://leetcode.com/problems/kth-largest-element-in-a-stream/description/",
                lvl: "E"
            },
            {
                id: "2",
                title: "Last Stone Weight",
                vidLink: "https://youtu.be/B-QCq79-Vfw",
                probLink: "https://leetcode.com/problems/last-stone-weight/description/",
                lvl: "E"
            },
            {
                id: "3",
                title: "K Closest Points to Origin",
                vidLink: "https://youtu.be/rI2EBUEMfTk",
                probLink: "https://leetcode.com/problems/k-closest-points-to-origin/description/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Kth Largest Element In An Array",
                vidLink: "https://youtu.be/XEmy13g1Qxc",
                probLink: "https://leetcode.com/problems/kth-largest-element-in-an-array/description/",
                lvl: "M"
            },
            {
                id: "5",
                title: "Task Scheduler",
                vidLink: "https://youtu.be/s8p8ukTyA2I",
                probLink: "https://leetcode.com/problems/task-scheduler/description/",
                lvl: "M"
            },
            {
                id: "6",
                title: "Design Twitter",
                vidLink: "https://youtu.be/pNichitDD2E",
                probLink: "https://leetcode.com/problems/design-twitter/description/",
                lvl: "M"
            },
            {
                id: "7",
                title: "Find Median From Data Stream",
                vidLink: "https://youtu.be/itmhHWaHupI",
                probLink: "https://leetcode.com/problems/find-median-from-data-stream/description/",
                lvl: "H"
            }  
        ]
    },
    {
        topic: "Intervals",
        items: [
            {
                id: "1",
                title: "Insert Interval",
                vidLink: "https://youtu.be/A8NUOmlwOlM",
                probLink: "https://leetcode.com/problems/insert-interval/description/",
                lvl: "M"
            },
            {
                id: "2",
                title: "Merge Intervals",
                vidLink: "https://youtu.be/44H3cEC2fFM",
                probLink: "https://leetcode.com/problems/merge-intervals/description/",
                lvl: "M"
            },
            {
                id: "3",
                title: "Non Overlapping Intervals",
                vidLink: "https://youtu.be/nONCGxWoUfM",
                probLink: "https://leetcode.com/problems/non-overlapping-intervals/description/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Meeting Rooms",
                vidLink: "https://youtu.be/PaJxqZVPhbg",
                probLink: "https://neetcode.io/problems/meeting-schedule/",
                lvl: "E"
            },
            {
                id: "5",
                title: "Meeting Rooms II",
                vidLink: "https://youtu.be/FdzJmTCVyJU",
                probLink: "https://neetcode.io/problems/meeting-schedule-ii/",
                lvl: "M"
            },
            {
                id: "6",
                title: "Minimum Interval to Include Each Query",
                vidLink: "https://youtu.be/5hQ5WWW5awQ",
                probLink: "https://leetcode.com/problems/minimum-interval-to-include-each-query/description/",
                lvl: "H"
            }
            
        ]
    },
    {
        topic: "Greedy",
        items: [
            {
                id: "1",
                title: "https://youtu.be/5WZl3MMT0Eg",
                vidLink: "https://youtu.be/5WZl3MMT0Eg",
                probLink: "https://leetcode.com/problems/maximum-subarray/description/",
                lvl: "M"
            },
            {
                id: "2",
                title: "Jump Game",
                vidLink: "https://youtu.be/Yan0cv2cLy8",
                probLink: "https://leetcode.com/problems/jump-game/description/",
                lvl: "M"
            },
            {
                id: "3",
                title: "Jump Game II",
                vidLink: "https://youtu.be/dJ7sWiOoK7g",
                probLink: "https://leetcode.com/problems/jump-game-ii/description/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Gas Station",
                vidLink: "https://youtu.be/lJwbPZGo05A",
                probLink: "https://leetcode.com/problems/gas-station/description/",
                lvl: "M"
            },
            {
                id: "5",
                title: "Hand of Straights",
                vidLink: "https://youtu.be/amnrMCVd2YI",
                probLink: "https://leetcode.com/problems/hand-of-straights/description/",
                lvl: "M"
            },
            {
                id: "6",
                title: "Merge Triplets to Form Target Triplet",
                vidLink: "https://youtu.be/kShkQLQZ9K4",
                probLink: "https://leetcode.com/problems/merge-triplets-to-form-target-triplet/description/",
                lvl: "M"
            },
            {
                id: "7",
                title: "Partition Labels",
                vidLink: "https://youtu.be/B7m8UmZE-vw",
                probLink: "https://leetcode.com/problems/partition-labels/description/",
                lvl: "M"
            },
            {
                id: "8",
                title: "Valid Parenthesis String",
                vidLink: "https://youtu.be/QhPdNS143Qg",
                probLink: "https://leetcode.com/problems/valid-parenthesis-string/description/",
                lvl: "M"
            }
        ]
    },
    {
        topic: "Backtracking",
        items: [
            {
                id: "1",
                title: "Subsets",
                vidLink: "https://youtu.be/REOH22Xwdkk",
                probLink: "https://leetcode.com/problems/subsets/description/",
                lvl: "M"
            },
            {
                id: "2",
                title: "Combination Sum",
                vidLink: "https://youtu.be/GBKI9VSKdGg",
                probLink: "https://leetcode.com/problems/combination-sum/description/",
                lvl: "M"
            },
            {
                id: "3",
                title: "Permutations",
                vidLink: "https://youtu.be/FZe0UqISmUw",
                probLink: "https://leetcode.com/problems/permutations/description/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Subsets II",
                vidLink: "https://youtu.be/Vn2v6ajA7U0",
                probLink: "https://leetcode.com/problems/subsets-ii/description/",
                lvl: "M"
            },
            {
                id: "5",
                title: "Combination Sum II",
                vidLink: "https://youtu.be/FOyRpNUSFeA",
                probLink: "https://leetcode.com/problems/combination-sum-ii/description/",
                lvl: "M"
            },
            {
                id: "6",
                title: "Word Search",
                vidLink: "https://youtu.be/pfiQ_PS1g8E",
                probLink: "https://leetcode.com/problems/word-search/description/",
                lvl: "M"
            },
            {
                id: "7",
                title: "Palindrome Partitioning",
                vidLink: "https://youtu.be/3jvWodd7ht0",
                probLink: "https://leetcode.com/problems/palindrome-partitioning/description/",
                lvl: "M"
            },
            {
                id: "8",
                title: "Letter Combinations of a Phone Number",
                vidLink: "https://youtu.be/0snEunUacZY",
                probLink: "https://leetcode.com/problems/letter-combinations-of-a-phone-number/description/",
                lvl: "M"
            },
            {
                id: "9",
                title: "N Queens",
                vidLink: "https://youtu.be/Ph95IHmRp5M",
                probLink: "https://leetcode.com/problems/n-queens/description/",
                lvl: "H"
            }
        ]
    },
    {
        topic: "Graphs",
        items: [
            {
                id: "1",
                title: "Number of Islands",
                vidLink: "https://youtu.be/pV2kpPD66nE",
                probLink: "https://leetcode.com/problems/number-of-islands/description/",
                lvl: "M"
            },
            {
                id: "2",
                title: "Max Area of Island",
                vidLink: "https://youtu.be/iJGr1OtmH0c",
                probLink: "https://leetcode.com/problems/max-area-of-island/description/",
                lvl: "M"
            },
            {
                id: "3",
                title: "Clone Graph",
                vidLink: "https://youtu.be/mQeF6bN8hMk",
                probLink: "https://leetcode.com/problems/clone-graph/description/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Walls And Gates",
                vidLink: "https://youtu.be/e69C6xhiSQE",
                probLink: "https://leetcode.com/problems/walls-and-gates/description/",
                lvl: "M",
                prob: true
            },
            {
                id: "5",
                title: "Rotting Oranges",
                vidLink: "https://youtu.be/y704fEOx0s0",
                probLink: "https://leetcode.com/problems/rotting-oranges/description/",
                lvl: "M"
            },
            {
                id: "6",
                title: "Pacific Atlantic Water Flow",
                vidLink: "https://youtu.be/s-VkcjHqkGI",
                probLink: "https://leetcode.com/problems/pacific-atlantic-water-flow/description/",
                lvl: "M"
            },
            {
                id: "7",
                title: "Surrounded Regions",
                vidLink: "https://youtu.be/9z2BunfoZ5Y",
                probLink: "https://leetcode.com/problems/surrounded-regions/description/",
                lvl: "M"
            },
            {
                id: "8",
                title: "Course Schedule",
                vidLink: "https://youtu.be/EgI5nU9etnU",
                probLink: "https://leetcode.com/problems/course-schedule/description/",
                lvl: "M"
            },
            {
                id: "9",
                title: "Course Schedule II",
                vidLink: "https://youtu.be/Akt3glAwyfY",
                probLink: "https://leetcode.com/problems/course-schedule-ii/description/",
                lvl: "M"
            },
            {
                id: "10",
                title: "Graph Valid Tree",
                vidLink: "https://youtu.be/bXsUuownnoQ",
                probLink: "https://leetcode.com/problems/graph-valid-tree/description/",
                lvl: "M",
                prob: true
            },
            {
                id: "11",
                title: "Number of Connected Components In An Undirected Graph",
                vidLink: "https://youtu.be/8f1XPm4WOUc",
                probLink: "https://leetcode.com/problems/number-of-connected-components-in-an-undirected-graph/description/",
                lvl: "M",
                prob: true
            },
            {
                id: "12",
                title: "Redundant Connection",
                vidLink: "https://youtu.be/FXWRE67PLL0",
                probLink: "https://leetcode.com/problems/redundant-connection/description/",
                lvl: "M"
            },
            {
                id: "13",
                title: "Word Ladder",
                vidLink: "https://youtu.be/h9iTnkgv05E",
                probLink: "https://leetcode.com/problems/word-ladder/description/",
                lvl: "H"
            } 
        ]
    },
    {
        topic: "Advanced Graphs",
        items: [
            {
                id: "1",
                title: "Reconstruct Itinerary",
                vidLink: "https://youtu.be/ZyB_gQ8vqGA",
                probLink: "https://leetcode.com/problems/reconstruct-itinerary/description/",
                lvl: "H"
            },
            {
                id: "2",
                title: "Min Cost to Connect All Points",
                vidLink: "https://youtu.be/f7JOBJIC-NA",
                probLink: "https://leetcode.com/problems/min-cost-to-connect-all-points/description/",
                lvl: "M"
            },
            {
                id: "3",
                title: "Network Delay Time",
                vidLink: "https://youtu.be/EaphyqKU4PQ",
                probLink: "https://leetcode.com/problems/network-delay-time/description/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Swim In Rising Water",
                vidLink: "https://youtu.be/amvrKlMLuGY",
                probLink: "https://leetcode.com/problems/swim-in-rising-water/description/",
                lvl: "H"
            },
            {
                id: "5",
                title: "Alien Dictionary",
                vidLink: "https://youtu.be/6kTZYvNNyps",
                probLink: "https://leetcode.com/problems/alien-dictionary/description/",
                lvl: "H",
                prob: true
            },
            {
                id: "6",
                title: "Cheapest Flights Within K Stops",
                vidLink: "https://youtu.be/5eIK3zUdYmE",
                probLink: "https://leetcode.com/problems/cheapest-flights-within-k-stops/description/",
                lvl: "M"
            }
        ]
    },
    {
        topic: "1-D Dynamic Programming",
        items: [
            {
                id: "1",
                title: "Climbing Stairs",
                vidLink: "https://youtu.be/Y0lT9Fck7qI",
                probLink: "https://leetcode.com/problems/climbing-stairs/description/",
                lvl: "E"
            },
            {
                id: "2",
                title: "Min Cost Climbing Stairs",
                vidLink: "https://youtu.be/ktmzAZWkEZ0",
                probLink: "https://leetcode.com/problems/min-cost-climbing-stairs/description/",
                lvl: "E"
            },
            {
                id: "3",
                title: "House Robber",
                vidLink: "https://youtu.be/73r3KWiEvyk",
                probLink: "https://leetcode.com/problems/house-robber/description/",
                lvl: "M"
            },
            {
                id: "4",
                title: "House Robber II",
                vidLink: "https://youtu.be/rWAJCfYYOvM",
                probLink: "https://leetcode.com/problems/house-robber-ii/description/",
                lvl: "M"
            },
            {
                id: "5",
                title: "Longest Palindromic Substring",
                vidLink: "https://youtu.be/XYQecbcd6_c",
                probLink: "https://leetcode.com/problems/longest-palindromic-substring/description/",
                lvl: "M"
            },
            {
                id: "6",
                title: "Palindromic Substrings",
                vidLink: "https://youtu.be/4RACzI5-du8",
                probLink: "https://leetcode.com/problems/palindromic-substrings/description/",
                lvl: "M"
            },
            {
                id: "7",
                title: "Decode Ways",
                vidLink: "https://youtu.be/6aEyTjOwlJU",
                probLink: "https://leetcode.com/problems/decode-ways/description/",
                lvl: "M"
            },
            {
                id: "8",
                title: "Coin Change",
                vidLink: "https://youtu.be/H9bfqozjoqs",
                probLink: "https://leetcode.com/problems/coin-change/description/",
                lvl: "M"
            },
            {
                id: "9",
                title: "Maximum Product Subarray",
                vidLink: "https://youtu.be/lXVy6YWFcRM",
                probLink: "https://leetcode.com/problems/maximum-product-subarray/description/",
                lvl: "M"
            },
            {
                id: "10",
                title: "Word Break",
                vidLink: "https://youtu.be/Sx9NNgInc3A",
                probLink: "https://leetcode.com/problems/word-break/description/",
                lvl: "M"
            },
            {
                id: "11",
                title: "Longest Increasing Subsequence",
                vidLink: "https://youtu.be/cjWnW0hdF1Y",
                probLink: "https://leetcode.com/problems/longest-increasing-subsequence/description/",
                lvl: "M"
            },
            {
                id: "12",
                title: "Partition Equal Subset Sum",
                vidLink: "https://youtu.be/IsvocB5BJhw",
                probLink: "https://leetcode.com/problems/partition-equal-subset-sum/description/",
                lvl: "M"
            }
        ]
    },
    {
        topic: "2-D Dynamic Programming",
        items: [
            {
                id: "1",
                title: "Unique Paths",
                vidLink: "https://youtu.be/IlEsdxuD4lY",
                probLink: "https://leetcode.com/problems/unique-paths/description/",
                lvl: "M"
            },
            {
                id: "2",
                title: "Longest Common Subsequence",
                vidLink: "https://youtu.be/Ua0GhsJSlWM",
                probLink: "https://leetcode.com/problems/longest-common-subsequence/description/",
                lvl: "M"
            },
            {
                id: "3",
                title: "Best Time to Buy And Sell Stock With Cooldown",
                vidLink: "https://youtu.be/I7j0F7AHpb8",
                probLink: "https://leetcode.com/problems/best-time-to-buy-and-sell-stock-with-cooldown/description/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Coin Change II",
                vidLink: "https://youtu.be/Mjy4hd2xgrs",
                probLink: "https://leetcode.com/problems/coin-change-ii/description/",
                lvl: "M"
            },
            {
                id: "5",
                title: "Target Sum",
                vidLink: "https://youtu.be/g0npyaQtAQM",
                probLink: "https://leetcode.com/problems/target-sum/description/",
                lvl: "M"
            },
            {
                id: "6",
                title: "Interleaving String",
                vidLink: "https://youtu.be/3Rw3p9LrgvE",
                probLink: "https://leetcode.com/problems/interleaving-string/description/",
                lvl: "M"
            },
            {
                id: "7",
                title: "Longest Increasing Path In a Matrix",
                vidLink: "https://youtu.be/wCc_nd-GiEc",
                probLink: "https://leetcode.com/problems/longest-increasing-path-in-a-matrix/description/",
                lvl: "H"
            },
            {
                id: "8",
                title: "Distinct Subsequences",
                vidLink: "https://youtu.be/-RDzMJ33nx8",
                probLink: "https://leetcode.com/problems/distinct-subsequences/description/",
                lvl: "H"
            },
            {
                id: "9",
                title: "Edit Distance",
                vidLink: "https://youtu.be/XYi2-LPrwm4",
                probLink: "https://leetcode.com/problems/edit-distance/description/",
                lvl: "M"
            },
            {
                id: "10",
                title: "Burst Balloons",
                vidLink: "https://youtu.be/VFskby7lUbw",
                probLink: "https://leetcode.com/problems/burst-balloons/description/",
                lvl: "H"
            },
            {
                id: "11",
                title: "Regular Expression Matching",
                vidLink: "https://youtu.be/HAA8mgxlov8",
                probLink: "https://leetcode.com/problems/regular-expression-matching/description/",
                lvl: "H"
            }
        ]
    },
    {
        topic: "Bit Manipulation",
        items: [
            {
                id: "1",
                title: "Single Number",
                vidLink: "https://youtu.be/qMPX1AOa83k",
                probLink: "https://leetcode.com/problems/single-number/description/",
                lvl: "E"
            },
            {
                id: "2",
                title: "Number of 1 Bits",
                vidLink: "https://youtu.be/5Km3utixwZs",
                probLink: "https://leetcode.com/problems/number-of-1-bits/description/",
                lvl: "E"
            },
            {
                id: "3",
                title: "Counting Bits",
                vidLink: "https://youtu.be/RyBM56RIWrM",
                probLink: "https://leetcode.com/problems/counting-bits/description/",
                lvl: "E"
            },
            {
                id: "4",
                title: "Reverse Bits",
                vidLink: "https://youtu.be/UcoN6UjAI64",
                probLink: "https://leetcode.com/problems/reverse-bits/description/",
                lvl: "E"
            },
            {
                id: "5",
                title: "Missing Number",
                vidLink: "https://youtu.be/WnPLSRLSANE",
                probLink: "https://leetcode.com/problems/missing-number/description/",
                lvl: "E"
            },
            {
                id: "6",
                title: "Sum of Two Integers",
                vidLink: "https://youtu.be/gVUrDV4tZfY",
                probLink: "https://leetcode.com/problems/sum-of-two-integers/description/",
                lvl: "M"
            },
            {
                id: "7",
                title: "Reverse Integer",
                vidLink: "https://youtu.be/HAgLH58IgJQ",
                probLink: "https://leetcode.com/problems/reverse-integer/description/",
                lvl: "M"
            }
        ]
    },
    {
        topic: "Math & Geometry",
        items: [
            {
                id: "1",
                title: "Rotate Image",
                vidLink: "https://youtu.be/fMSJSS7eO1w",
                probLink: "https://leetcode.com/problems/rotate-image/description/",
                lvl: "M"
            },
            {
                id: "2",
                title: "Spiral Matrix",
                vidLink: "https://youtu.be/BJnMZNwUk1M",
                probLink: "https://leetcode.com/problems/spiral-matrix/description/",
                lvl: "M"
            },
            {
                id: "3",
                title: "Set Matrix Zeroes",
                vidLink: "https://youtu.be/T41rL0L3Pnw",
                probLink: "https://leetcode.com/problems/set-matrix-zeroes/description/",
                lvl: "M"
            },
            {
                id: "4",
                title: "Happy Number",
                vidLink: "https://youtu.be/ljz85bxOYJ0",
                probLink: "https://leetcode.com/problems/happy-number/description/",
                lvl: "E"
            },
            {
                id: "5",
                title: "Plus One",
                vidLink: "https://youtu.be/jIaA8boiG1s",
                probLink: "https://leetcode.com/problems/plus-one/description/",
                lvl: "E"
            },
            {
                id: "6",
                title: "Pow(x, n)",
                vidLink: "https://youtu.be/g9YQyYi4IQQ",
                probLink: "https://leetcode.com/problems/powx-n/description/",
                lvl: "M"
            },
            {
                id: "7",
                title: "Multiply Strings",
                vidLink: "https://youtu.be/1vZswirL8Y8",
                probLink: "https://leetcode.com/problems/multiply-strings/description/",
                lvl: "M"
            },
            {
                id: "8",
                title: "Detect Squares",
                vidLink: "https://youtu.be/bahebearrDc",
                probLink: "https://leetcode.com/problems/detect-squares/description/",
                lvl: "M"
            }
        ]
    }
]